import { FormControlLabel } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUserRights } from "../../../contexts/UserRightsContext";
import InputSelect from "../../common/InputSelect";
import "./AgentSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  label: {
    fontSize: 12,
    margin: 0,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));

export default function AgentSettings(props) {
  const classes = useStyles();

  const [lineType, setLineType] = useState();
  const [agentType, setAgentType] = useState();
  const [masterAgent, setMasterAgent] = useState();
  const [masterAgentId, setMasterAgentId] = useState(
    props.AgentInfo.distributor
  );
  const [agentPerHead, setAgentPerHead] = useState();
  const [language, setLanguage] = useState();
  const [currency, setCurrencies] = useState();
  const [books, setBooks] = useState();
  const [grouping, setGrouping] = useState();
  const [lineTypeID, setLineTypeID] = useState(props.AgentInfo.idLineType);
  const [groupingID, setGroupingID] = useState(props.AgentInfo.idGrouping);
  const [bookID, setBookID] = useState(props.AgentInfo.idBook);
  const [currencyID, setCurrencyID] = useState(props.AgentInfo.idCurrency);
  const [agentPerHeadID, setAgentPerHeadID] = useState(
    props.AgentInfo.idAgentPerHead
  );
  const [languageID, setLanguageID] = useState(props.AgentInfo.idLanguage);
  const [agentID, setAgentID] = useState(0);
  const [enable, setEnable] = React.useState(props.AgentInfo.enable);
  const [agentTypeID, setAgentTypeID] = useState(props.AgentInfo.idAgentType);
  const [isDistributed, setIsDistributed] = React.useState(
    props.AgentInfo.isDistributed
  );
  const [isDistributor, setIsDistributor] = React.useState(
    props.AgentInfo.isDistributor
  );
  const [onlineAcces, setOnlineAccess] = React.useState(
    props.AgentInfo.onlineAccess
  );
  const [dontXferPlayerActivity, setDontXferPlayerActivity] = React.useState(
    props.AgentInfo.dontXferPlayerActivity
  );
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  let history = useHistory();

  useEffect(() => {
    setLineTypeID(props.AgentInfo.idLineType);
    setGroupingID(props.AgentInfo.idGrouping);
    setBookID(props.AgentInfo.idBook);
    setCurrencyID(props.AgentInfo.idCurrency);
    //setAgentPerHeadID(props.AgentInfo.idAgentPerHead);
    setLanguageID(props.AgentInfo.idLanguage);
    setEnable(props.AgentInfo.enable);
    setAgentTypeID(props.AgentInfo.idAgentType);
    setIsDistributed(props.AgentInfo.isDistributed);
    setIsDistributor(props.AgentInfo.isDistributor);
    setOnlineAccess(props.AgentInfo.onlineAccess);
    setDontXferPlayerActivity(props.AgentInfo.dontXferPlayerActivity);
    setMasterAgentId(props.AgentInfo.distributor)
  }, [props.AgentInfo]);

  useEffect(() => {
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      "/Agent/Agent_GetList2Result?idUser=" +
      userInfo.userId;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let masterAgentInfo = data.map((v) => {
          v.idLineType = v.idAgent;
          v.description = v.agent;
          return v;
        });
        console.log("masterAgentInfo====>", masterAgentInfo);
        setMasterAgent(masterAgentInfo);
      });
  }, [setMasterAgent]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Player/GetBooks";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let bookInfo = data.map((v) => {
          v.idBook = v.idBook;
          v.description = v.description;
          return v;
        });
        setBooks(bookInfo);
      });
  }, [setBooks]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/LineType/GetLineTypes";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let lineTypeInfo = data.map((v) => {
          v.idLineType = v.idLineType;
          v.description = v.description;
          return v;
        });
        setLineType(lineTypeInfo);
      });
  }, [setLineType]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Agent/Grouping_GetList";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let groupingInfo = data.map((v) => {
          v.idLineType = v.idGrouping;
          v.description = v.description;
          return v;
        });
        setGrouping(groupingInfo);
      });
  }, [setGrouping]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Agent/AgentType_GetList";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let agentTypeInfo = data.map((v) => {
          v.idLineType = v.idAgentType;
          v.description = v.agentType;
          return v;
        });
        setAgentType(agentTypeInfo);
      });
  }, [setAgentType]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Agent/Currency_GetList";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let currencyInfo = data.map((v) => {
          v.idLineType = v.idCurrency;
          v.description = v.description;
          return v;
        });
        setCurrencies(currencyInfo);
      });
  }, [setCurrencies]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Agent/AgentPerHead_GetList";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let agentPerHeadInfo = data.map((v) => {
          v.idLineType = v.idAgentPerHead;
          v.description = v.description;
          return v;
        });
        setAgentPerHead(agentPerHeadInfo);
      });
  }, [setAgentPerHead]);

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/User/GetLanguages";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let languageInfo = data.map((v) => {
          v.idLineType = v.idLanguage;
          v.description = v.langDesc;
          return v;
        });
        setLanguage(languageInfo);
      });
  }, [setLanguage]);

  function changeBookID(value) {
    setBookID(value);
  }
  function changeGroupingID(value) {
    setGroupingID(value);
  }
  function changeCurrencyID(value) {
    setCurrencyID(value);
  }
  function changeLineTypeID(value) {
    setLineTypeID(value);
  }
  function changeAgentID(value) {
    setAgentID(value);
  }
  function changeAgentPerHeadID(value) {
    setAgentPerHeadID(value);
  }
  function changeLanguageID(value) {
    setLanguageID(value);
  }

  function changeAgentTypeID(value) {
    setAgentTypeID(value);
  }

  function changeMasterAgentID(value) {
    setMasterAgentId(value);
  }

  const handleChangeEnable = () => {
    setEnable(!enable);
  };
  const handleChangeIsDistributed = () => {
    setIsDistributed(!isDistributed);
  };
  const handleChangeIsDistributor = () => {
    setIsDistributor(!isDistributor);
  };
  const handleChangeOnlineAccess = () => {
    setOnlineAccess(!onlineAcces);
  };

  const handleChangeDontXferPlayerActivity = () => {
    setDontXferPlayerActivity(!dontXferPlayerActivity);
  };

  const handleSave = () => {
    AgentUpdate();
  };

  const [localAgent, setLocalAgent] = useState(props.AgentInfo);
  const handleChange = (event, key, value) => {
    setLocalAgent({
      ...localAgent,
      [key]: event ? event.target.value : value,
    });
    console.log(localAgent, key)
  };

  useEffect(() => {
    setLocalAgent(props.AgentInfo);
  }, [props.AgentInfo]);

  const handleClose = () => {
    let pushURL = "/home/";
    return (
      <React.Fragment>
        {/* //this.props.location.state. asi se agarran los datos en el otro componente */}

        <div>
          {history.push(pushURL)}

        </div>
      </React.Fragment>
    );
  };

  const AgentUpdate = () => {
    let AgentRequest = {
      IdAgent: props.AgentInfo.idAgent,
      Enable: enable,
      DontXferPlayerActivity: dontXferPlayerActivity,
      IsDistributor: isDistributor,
      Distributor: props.AgentInfo.distributor,
      CommSports: localAgent.commSports,
      CommCasino: localAgent.commCasino,
      CommHorses: localAgent.commHorses,
      IdAgentType: agentTypeID,
      IdCurrency: currencyID,
      IdBook: bookID,
      IdGrouping: groupingID == -1 ? null : groupingID,
      Agent1: props.AgentInfo.agent,
      Name: props.AgentInfo.name,
      Password: props.AgentInfo.password,
      City: props.AgentInfo.city,
      State: props.AgentInfo.state,
      Country: props.AgentInfo.country,
      Address1: props.AgentInfo.address1,
      Address2: props.AgentInfo.address2,
      Email: props.AgentInfo.email,
      Phone: props.AgentInfo.phone,
      Fax: props.AgentInfo.fax,
      Zip: props.AgentInfo.zip,
      OnlineAccess: onlineAcces,
      OnlineMessage: props.AgentInfo.onlineMessage,
      IdLineType: lineTypeID,
      IdAgentPerHead: agentPerHeadID == -1 ? null : agentPerHeadID,
      IdLanguage: languageID == -1 ? null : languageID,
      LastModificationUser: userInfo.userId,
      Distributor: masterAgentId == -1 ? null : masterAgentId
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Agent/Agent_Update",
      //url: 'https://localhost:44337/api/Agent/Agent_Update',
      data: AgentRequest,
    }).then((response) => {
      if (response.data === -1) {
        alert("Data Successfully Updated");
        props.getAgentInfo();
      }
      console.log("response", response);
    });
  };

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  return (
    <React.Fragment>
      <br />

      {props.AgentInfo && (
        <form>
          <div className={`grid grid-cols-2 w-full gap-4`}>
            <div className="vertical-options">
              <InputSelect
                variant="outlined"
                size="small"
                label="Type"
                name="name"
                data={agentType}
                placeholder="Agent Type"
                setSelectValue={changeAgentTypeID}
                startValue={agentTypeID}
              />
              <div className="flex flex-row gap-4">
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Master Agent"
                  name="name"
                  data={masterAgent}
                  setSelectValue={changeMasterAgentID}
                  startValue={masterAgentId}
                  placeholder="Master Agent"
                />
                <Button
                  className="!w-4"
                  variant="contained"
                  color="primary"
                  onClick={() => setMasterAgentId(-1)}
                >
                  Clean
                </Button>
              </div>
              <InputSelect
                variant="outlined"
                size="small"
                label="Book"
                name="name"
                data={books}
                placeholder="Book"
                setSelectValue={changeBookID}
                startValue={bookID}
              />
              <div className="flex flex-row gap-4">
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Grouping"
                  name="name"
                  data={grouping}
                  placeholder="Grouping"
                  setSelectValue={changeGroupingID}
                  startValue={groupingID}
                />
                <Button
                  className="!w-4"
                  variant="contained"
                  color="primary"
                  onClick={() => setGroupingID(-1)}
                >
                  Clean
                </Button>
              </div>
              <InputSelect
                variant="outlined"
                size="small"
                label="Currency"
                name="name"
                data={currency}
                placeholder="Currency"
                setSelectValue={changeCurrencyID}
                startValue={currencyID}
              />
              <div className="flex flex-row gap-4">
                <InputSelect
                  disabled={!hasRights(317)}
                  variant="outlined"
                  size="small"
                  label="Line Type"
                  name="name"
                  data={lineType}
                  placeholder="Line Type"
                  setSelectValue={changeLineTypeID}
                  startValue={lineTypeID ?? ""}
                />
                <Button
                  className="!w-4"
                  variant="contained"
                  color="primary"
                  onClick={() => setLineTypeID(null)}
                >
                  Clean
                </Button>
              </div>
              <div className="flex flex-row gap-4">
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Per Head"
                  name="name"
                  data={agentPerHead}
                  placeholder="Agent per head"
                  setSelectValue={changeAgentPerHeadID}
                  startValue={agentPerHeadID}
                />
                <Button
                  className="!w-4"
                  variant="contained"
                  color="primary"
                  onClick={() => setAgentPerHeadID(-1)}
                >
                  Clean
                </Button>
              </div>

              <div className="flex flex-row gap-4">
                <InputSelect
                  variant="outlined"
                  size="small"
                  label="Language"
                  name="name"
                  data={language}
                  placeholder="Language"
                  setSelectValue={changeLanguageID}
                  startValue={languageID}
                />
                <Button
                  className="!w-4"
                  variant="contained"
                  color="primary"
                  onClick={() => setLanguageID(-1)}
                >
                  Clean
                </Button>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <div className="!gap-0 vertical-options">
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={enable}
                      onChange={handleChangeEnable}
                      color="primary"
                    />
                  }
                  label="Enable"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={isDistributor}
                      onChange={handleChangeIsDistributor}
                      color="primary"
                    />
                  }
                  label="Distributor"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={onlineAcces}
                      onChange={handleChangeOnlineAccess}
                      color="primary"
                    />
                  }
                  label="Online Access"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={dontXferPlayerActivity}
                      onChange={handleChangeDontXferPlayerActivity}
                      color="primary"
                    />
                  }
                  label="Don't Xfer Player Activity"
                />
              </div>
              <div className="vertical-options">
                <TextField
                  variant="outlined"
                  type="number"
                  label="Make Up"
                  //value={homeNumber}
                  multiline={false}
                />
                <TextField
                  variant="outlined"
                  type="number"
                  label="Comm % Sports"
                  value={localAgent.commSports}
                  onChange={(event) => handleChange(event, "CommSports")}
                  multiline={false}
                />
                <TextField
                  variant="outlined"
                  type="number"
                  label="Comm % Casino"
                  value={localAgent.commCasino}
                  onChange={(event) => handleChange(event, "CommCasino")}
                  multiline={false}
                />
                <TextField
                  variant="outlined"
                  type="number"
                  label="Comm % Horses"
                  value={localAgent.commHorses}
                  onChange={(event) => handleChange(event, "CommHorses")}
                  multiline={false}
                />
              </div>
            </div>

            <div className="flex flex-row gap-4">
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handleSave}
              >
                Save
              </Button>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handleClose}
              >
                Close
              </Button>
            </div>
          </div>
        </form>
      )}
    </React.Fragment>
  );
}
